import React, { useContext, useEffect, useState } from 'react';
import { FieldError } from '../../hybrid/wrappers';

import ReCAPTCHA from 'react-google-recaptcha';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UserContext from '../../common/utils/getContext';

const Captcha = ({ attribute, site_key, errors, compStyle, value, tryCount, version, setFormData, attempts, align }) => {
    const [visible, setVisible] = useState(false);
    const { lang } = useContext(UserContext);

    function onChange(value) {
        if (value) {
            setFormData(attribute, value);
        }
    }

    useEffect(() => {
        if (!!errors?.length || errors?.message) {
            if (typeof window !== 'undefined') {
                if (version === 'reCaptcha_v2' && value?.value == 1 && window.grecaptcha) {
                    window.grecaptcha.reset();
                }
            }
        }
    }, [errors, value?.value, version]);

    useEffect(() => {
        if (`${value.value}` === '1') {
            if (value.attribute === 'user::auth') {
                if (tryCount <= attempts) {
                    setVisible(true);
                }
            } else {
                setVisible(true);
            }
        }
    }, [attempts, tryCount, value.attribute, value.value]);

    if (!site_key || !visible) return null;
    return (
        <div
            style={{ marginBottom: '24px' }}
            className={classNames('ReCaptchaProvider', align === 'center' ? 'ReCaptchaProviderCenter' : '')}
        >
            {version === 'reCaptcha_v3' ? (
                <GoogleReCaptchaProvider reCaptchaKey={site_key}>
                    <GoogleReCaptcha onVerify={onChange} />
                </GoogleReCaptchaProvider>
            ) : version === 'reCaptcha_v2' ? (
                <ReCAPTCHA hl={lang} sitekey={site_key} onChange={onChange} />
            ) : (
                ''
            )}
            {errors && errors.length
                ? errors.map((err, idx) => (
                      <FieldError compStyle={compStyle?.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
        </div>
    );
};

Captcha.propTypes = {
    setFormData: PropTypes.func,
    attribute: PropTypes.string,
    site_key: PropTypes.string,
    errors: PropTypes.array,
    compStyle: PropTypes.object,
    value: PropTypes.object,
    captchaCount: PropTypes.number,
    tryCount: PropTypes.number,
    version: PropTypes.oneOf(['reCaptcha_v3', 'reCaptcha_v2'])
};
export default React.memo(Captcha);
